/*jshint esversion: 11 */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge} from 'reactstrap';

import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import { getQuestionInfo, getQuestionList } from '../../api/question';
import moment from 'moment';
import CreateQuestionModal from './CreateQuestionModal';
import ViewQuestionModal from './ViewQuestionModal';
import UpdateQuestionModal from './UpdateQuestionModal';
import 'react-datepicker/dist/react-datepicker.css';
import validator from 'validator';
import { stringify as QStringify, parse as QParse } from 'qs';
import { useHistory } from 'react-router-dom';
import {
  CREATE_QUESTION,
  DELETE_QUESTION,
  UPDATE_QUESTION
} from '../Utility/PermissionKeys';
import { validatePermissionKey } from '../../helpers/permission';
import DeleteQuestionModal from './DeleteQuestionModal';
import FilterQuestionsModal from './FilterQuestionsModal';

const QuestionListPage = ({ authUser }) => {
  const history = useHistory();

  const [breadcrumbItems] = useState([
    { title: 'Questions', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [activeTab, ] = useState('Child');
  const [questionListLoading, setQuestionListLoading] = useState(true);
  const [questionList, setQuestionList] = useState([]);
  const [sortingRule, setSortingRule] = useState('updated_at$desc');

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [filterQuestionName, setFilterQuestionName] = useState('');
  const [filterError, setFilterError] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilterCount, setCurrentFilterCount] = useState(0);
  const [addQuestionModalOpen, setAddQuestionModalOpen] = useState(false);
  const [questionInfo, setQuestionInfo] = useState({});
  const [questionInfoLoading, setQuestionInfoLoading] = useState(false);
  const [questionInfoModalOpen, setQuestionInfoModalOpen] = useState(false);
  const [updateQuestionModalOpen, setUpdateQuestionModalOpen] = useState(false);
  const [, setExpectedDateFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [deleteQuestionModalOpen, setDeleteQuestionModalOpen] = useState(false);
  const [questionId, setQuestionId] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  // eslint-disable-next-line
  const [sortOrder, setSortOrder] = useState('name$asc');
  const [createdAtFilter, setCreatedAtFilter] = useState({
    startDate: null,
    endDate: null
  });

  let listElem = document.getElementById('questionList');
  let linkElem = document.getElementById('questionLink');

  useEffect(() => {
    if (listElem) listElem.classList.add('mm-active');
    if (linkElem) linkElem.classList.add('active');
    if (authUser) {
      fetchData();
      populateSearchOptions(history?.location?.search);
    }
    // eslint-disable-next-line
  }, [authUser, listElem, linkElem]);



  /**
   *
   * @param {string} str
   */
  function getValidDateInput(str) {
    return validator.isDate(str) ? new Date(str).toISOString() : '';
  }


  const toggleFilterModal = () => setFilterModalOpen(!filterModalOpen);

  const handlePagination = (page) => {
    fetchData(page, pagination.pageLimit, createQueryOptions());
  };

  const fetchData = async (
    current_page = 1,
    page_limit = 10,
    queryOptions = {},
    sortingOption = ''
  ) => {
    setQuestionListLoading(true);
    const response = await getQuestionList(
      current_page,
      page_limit,
      queryOptions,
      sortingOption
    );

    if (response) {
      setPagination({
        currentPage: response.metadata.page,
        pageLimit: response.metadata.limit,
        totalPages: response.metadata.total_pages,
        totalEntries: response.metadata.total_results
      });
      setQuestionList(response.data);
      setQuestionListLoading(false);
    }
  };

  /**
   *
   * @param {string} searchQuery
   */
  function populateSearchOptions(searchQuery) {
    const parsedQuery = QParse(searchQuery.substring(1));
    if (parsedQuery.filter_start_date) {
      setExpectedDateFilter((pv) => {
        return {
          ...pv,
          startDate: new Date(parsedQuery.filter_start_date)
        };
      });
    }
    if (parsedQuery.filter_end_date) {
      setExpectedDateFilter((pv) => {
        return {
          ...pv,
          endDate: new Date(parsedQuery.filter_end_date)
        };
      });
    }
    setFilterQuestionName(parsedQuery.filter_name);
    fetchData(1, null, parsedQuery, parsedQuery.sorting_option);
    setSortingRule(parsedQuery.sorting_option)
    updateFilterCount(parsedQuery);
  }

  function createQueryOptions(
    startDate = createdAtFilter.startDate,
    endDate = createdAtFilter.endDate,
    filterName = filterQuestionName,
    deletedStatus = isDeleted
  ) {
    setFilterError(false);
    if ((startDate && !endDate) || (!startDate && endDate)) {
      setFilterError('Select valid date range');
      return;
    }
    const startDateISOStringCreatedAt = getValidDateInput(startDate);
    const endDateISOStringCreatedAt = getValidDateInput(endDate);

    const queryOptions = {
      filter_name: filterName,
      filter_start_date: startDateISOStringCreatedAt,
      filter_end_date: endDateISOStringCreatedAt,
      include_deleted: deletedStatus
    };
    updateUrlPath(queryOptions);
    // updateFilterCount(queryOptions);
    // fetchData(1, null, queryOptions);
    return queryOptions;
  }

  function updateUrlPath(queryOptions) {
    const queryString = QStringify(queryOptions);
    history.replace(`/questions?${queryString}`);
  }


  function openAddQuestionModal() {
    setAddQuestionModalOpen(true);
  }

  function closeAddQuestionModal() {
    setAddQuestionModalOpen(false);
  }

  function openQuestionInfoModal(roleId) {
    fetchQuestionInfo(roleId);
    setQuestionInfoModalOpen(true);
  }

  function closeQuestionInfoModal() {
    setQuestionInfoModalOpen(false);
  }

  async function openUpdateQuestionModal(questionId) {
    fetchQuestionInfo(questionId);
    setUpdateQuestionModalOpen(true);
  }

  function closeUpdateQuestionModal() {
    setUpdateQuestionModalOpen(false);
  }
  async function openDeleteQuestionModal(questionId, requestType) {
    setQuestionId({
      questionId,
      requestType
    });
    setDeleteQuestionModalOpen(true);
  }

  async function fetchSortedList(sortingOption) {
    setSortingRule(sortingOption);
    const queryOptions = createQueryOptions();
    queryOptions.sorting_option = sortingOption;
    updateUrlPath(queryOptions);
    fetchData(1, null, queryOptions, sortingOption);
  }

  function closeDeleteQuestionModal() {
    setDeleteQuestionModalOpen(false);
  }

  // function resetFields() {
  //   setFilterQuestionName('');
  //   setSelectedReferenceOption(null);
  //   setExpectedDateFilter({
  //     startDate: null,
  //     endDate: null
  //   });
  //   setIsDeleted(false);
  // }

  async function fetchQuestionInfo(questionId) {
    setQuestionInfoLoading(true);
    const response = await getQuestionInfo(questionId);
    if (response) {
      setQuestionInfo(response);
      setQuestionInfoLoading(false);
    }
  }



  function closeFilterModal() {
    setFilterModalOpen(false);
  }

  function updateFilterCount(option) {
    let count = 0;
    Object.keys(option).forEach((i) => {
      if (option[i]?.toString()?.trim()?.length > 0 && option[i] !== false) {
        count += 1;
      }
    });
    setCurrentFilterCount(count);
  }

  return (
    <React.Fragment>
      <div className="page-content">

        <FilterQuestionsModal
          filterError={filterError}
          setFilterError={setFilterError}
          modalOpenState={filterModalOpen}
          closeModalHandler={closeFilterModal}
          fetchList={fetchData}
          updateFilterCount={updateFilterCount}
          updateUrlPath={updateUrlPath}
          questionName={filterQuestionName}
          setQuestionName={setFilterQuestionName}
          createdAtFilter={createdAtFilter}
          setCreatedAtFilter={setCreatedAtFilter}
          createQueryOptions={createQueryOptions}
          authUser={authUser}
          isDeleted={isDeleted}
          setIsDeleted={setIsDeleted}
        />
        <CreateQuestionModal
          modalOpenState={addQuestionModalOpen}
          closeModalHandler={closeAddQuestionModal}
          fetchNewQuestionList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options, sortingRule);
            }
          }}
          authUser={authUser}
          questionType={activeTab}
        />
        <ViewQuestionModal
          modalOpenState={questionInfoModalOpen}
          closeModalHandler={closeQuestionInfoModal}
          questionInfo={questionInfo}
          questionInfoLoading={questionInfoLoading}
          questionType={activeTab}
        />
        <UpdateQuestionModal
          modalOpenState={updateQuestionModalOpen}
          closeModalHandler={closeUpdateQuestionModal}
          questionInfo={questionInfo}
          questionInfoLoading={questionInfoLoading}
          fetchNewQuestionList={async () => {
            let options = await createQueryOptions();
            if (options) {
              await fetchData(1, null, options, sortingRule);
            }
          }}
          questionType={activeTab}
        />
        {questionId && (
          <DeleteQuestionModal
            modalOpenState={deleteQuestionModalOpen}
            closeModalHandler={closeDeleteQuestionModal}
            questionId={questionId.questionId}
            type={questionId.requestType}
            fetchNewData={async () => {
              let options = await createQueryOptions();
              if (options) {
                await fetchData(1, null, options, sortingRule);
              }
            }}
          />
        )}
        <Container fluid>
          <Breadcrumbs
            title="View Questions"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <>
                    <Row className="mt-2">
                      <Col md="2">
                        <FormGroup>
                          <Col md="12">
                            <Label className="col-form-label">
                              Show Entries
                            </Label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                fetchData(
                                  1,
                                  e.target.value,
                                  createQueryOptions(),
                                  sortingRule
                                );
                                setPagination({
                                  ...pagination,
                                  pageLimit: e.target.value
                                });
                              }}
                              value={pagination.pageLimit}
                              disabled={questionListLoading}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <Label className="col-form-label">
                            Sort Question
                          </Label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              fetchSortedList(e.target.value);
                            }}
                            value={sortingRule}
                            disabled={questionListLoading}
                          >
                            <option value="name$asc">Question Name (A-Z)</option>
                            <option value="name$desc">Question Name (Z-A)</option>
                            <option value="updated_at$desc">Update Time (Newest First)</option>
                            <option value="updated_at$asc">Update Time (Oldest First)</option>

                          </select>
                        </FormGroup>
                      </Col>
                      <Col className="d-flex justify-content-end align-items-center">
                        <Button
                          size="sm"
                          color="primary"
                          className=" waves-effect waves-light mr-3"
                          onClick={toggleFilterModal}
                        >
                          <i className="ri-filter-fill align-middle mr-2"></i>
                          <span>Filter Question</span>
                          {currentFilterCount > 0 && (
                            <Badge color="light" pill className="ml-2">
                              {currentFilterCount}
                            </Badge>
                          )}
                        </Button>
                        {validatePermissionKey(authUser, CREATE_QUESTION) && (
                          <Button
                            size="sm"
                            color="success"
                            className=" waves-effect waves-light"
                            onClick={openAddQuestionModal}
                          >
                            <i className="ri-add-line align-middle mr-2"></i>
                            Add Question
                          </Button>
                        )}
                      </Col>
                    </Row>

                    {questionListLoading ? (
                      <div className="text-center">
                        <PageDataLoader />
                      </div>
                    ) : (
                      <div className="table-rep-plugin">
                        <div
                          className="table-responsive mb-0"
                          data-pattern="priority-columns"
                        >
                          <Table
                            id="tech-companies-1"
                            striped
                            bordered
                            responsive
                          >
                            <thead>
                              <tr>
                                <th>SL. No</th>
                                <th>Name</th>

                                <th>Created At</th>
                                <th>Last Updated At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {questionList?.map((item, index) => (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{item.title}</td>

                                  <td>
                                    {moment(new Date(item.createdAt)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>
                                  <td>
                                    {moment(new Date(item.updatedAt)).format(
                                      'DD-MM-YYYY'
                                    )}
                                  </td>

                                  <td>
                                    <Button
                                      size="sm"
                                      color="primary"
                                      className=" waves-effect waves-light mr-2 mb-2"
                                      onClick={() => {
                                        openQuestionInfoModal(item._id);
                                      }}
                                    >
                                      <i className="fas fa-eye mr-2"></i>
                                      View
                                    </Button>
                                    {validatePermissionKey(
                                      authUser,
                                      UPDATE_QUESTION
                                    ) && (
                                        <Button
                                          size="sm"
                                          color="warning"
                                          className=" waves-effect waves-light mr-2 mb-2"
                                          onClick={() => {
                                            openUpdateQuestionModal(item._id);
                                          }}
                                        >
                                          <i className="fas fa-edit mr-2"></i>
                                          Edit
                                        </Button>
                                      )}
                                    {validatePermissionKey(
                                      authUser,
                                      DELETE_QUESTION
                                    ) && (
                                        <Button
                                          size="sm"
                                          color="danger"
                                          className=" waves-effect waves-light mb-2"
                                          onClick={() => {
                                            openDeleteQuestionModal(
                                              item._id,
                                              item.isDeleted
                                                ? 'restore'
                                                : 'delete'
                                            );
                                          }}
                                        >
                                          {item.isDeleted ? (
                                            <i className="fas fa-trash-restore mr-2"></i>
                                          ) : (
                                            <i className="fas fa-trash mr-2"></i>
                                          )}
                                          {item.isDeleted ? 'Restore' : 'Delete'}
                                        </Button>
                                      )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}
                    <Row className="mt-2">
                      <Col md="5">
                        <p>
                          <strong>
                            {' '}
                            Showing{' '}
                            {(pagination.currentPage - 1) *
                              pagination.pageLimit +
                              1}{' '}
                            to{' '}
                            {Math.min(
                              pagination.currentPage * pagination.pageLimit,
                              pagination.totalEntries
                            )}{' '}
                            of {pagination.totalEntries} entries
                          </strong>
                        </p>
                      </Col>
                      {!questionListLoading && questionList.length > 0 && (
                        <Col md="7">
                          <Paginator
                            totalPages={pagination.totalPages}
                            currentPage={pagination.currentPage}
                            changePage={handlePagination}
                          />
                        </Col>
                      )}
                    </Row>
                  </>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(QuestionListPage);
